<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    카테고리 관리
                </div>
                <board-category-component></board-category-component>
                <div class="pa20 text_center">
                    <el-button @click="$router.back()">목록</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BoardCategoryComponent from "@/components/board/BoardCategoryComponent";
    import EventBus from "@/utils/event-bus";
    export default {
        name: "JustFaqCategory",
        mixins: [],
        components: {BoardCategoryComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {}
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {
            save(){
                EventBus.$emit('writeCategory')
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>